import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import first from 'lodash/first';

import { LoadingIndicator } from 'common/components/preloader';
import ArticleLink from 'help/components/article_link';
import Sidebar from 'help/containers/sidebar';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import idx from 'idx';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';

export default class Category extends Component {
  componentDidMount() {
    this.props.fetchAllCategoriesIfNeeded();
    this.props.fetchArticles();
    trackMixpanel("Viewed help content", {
      "contentType": "article",
      "pageType": "category index",
      "categorySlug": this.props.params.categorySlug,
      "slug": null,
    });
  }

  componentWillReceiveProps(nextProps) {
    const curSlug = idx(this.props, _ => _.params.categorySlug);
    const nextSlug = idx(nextProps, _ => _.params.categorySlug);
    if (curSlug !== nextSlug) {
      nextProps.fetchArticles();
    }
  }

  render() {
    const { articles, isLoading, data, params } = this.props;

    if (!articles || !data || isLoading) {
      return <LoadingIndicator />;
    }

    const category = first(data.filter(({ slug }) => (slug === params.categorySlug)));

    return (<div className="help-content">
      <Meta
        title={`${category.title} | Help | crowdspring`}
        meta={[
          { name: 'description', content: category.html_meta_description },
          { name: 'keywords', content: category.html_meta_keywords },
        ]}
        link={[{ rel: 'canonical', href: getCanonicalURL(`/help/${params.categorySlug}/`) }]}
      />
      <div className="row">
        <div className="small-16 columns">
          <ul className="help-breadcrumb">
            <li><Link to="/help/">Help Center</Link></li>
            <li className="active">{ category.title }</li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="small-16 medium-10 large-11 columns">
          <h1 className="category-title">{category.title}</h1>
          <ul className="article-list">
            { articles.map(article => (
              <li key={v4()}>
                <h2><ArticleLink {...article} categorySlug={category.slug} /></h2>
              </li>
            ))}
          </ul>
        </div>
        <div className="small-16 medium-6 large-4 large-offset-1 columns">
          <Sidebar />
        </div>
      </div>
    </div>);
  }
}

Category.propTypes = {
  fetchArticles: PropTypes.func.isRequired,
  fetchAllCategoriesIfNeeded: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  articles: PropTypes.any,
  data: PropTypes.any,
  params: PropTypes.shape({
    categorySlug: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./help/components/category.jsx